module.exports = __webpack_public_path__ + "media/animation1-e.16801c24.mp4";